import 'styles/common';

import 'apps/application';
import 'apps/application/reactRails';
